
import { defineMessages } from 'react-intl'

export default defineMessages({
  copy: {
    id: 'containers.CustomerVoiceSelectorsPage.components.Row.copy',
    defaultMessage: 'Copy to clipboard',
  },
})
